import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import { ISettingsStore } from './settings/store';
import { IUserStore } from './user/types';

import settings from './settings/reducers';
import user from './user/reducers';

export const rootReducer = combineReducers({
  settings,
  user,
});

export interface IStore {
  settings: ISettingsStore;
  user: IUserStore;
}

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);



// WEBPACK FOOTER //
// ./src/services/store.ts